import { Divider, Tabs } from "antd";
import React from "react";

export const StyledTabsSHB = () => {
    return (
        <>
            <div className="mt-3">
                <Divider orientation="left">Horizontal Tabs</Divider>

                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="Tab 1" key="1">
                        Content of Tab Pane 1
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Tab 2" key="2">
                        Content of Tab Pane 2
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Tab 3" key="3">
                        Content of Tab Pane 3
                    </Tabs.TabPane>
                </Tabs>

                <Divider orientation="left" className="mt-10">Vertical Tabs</Divider>
                <Tabs
                    tabPosition={"left"}
                    items={new Array(3).fill(null).map((_, i) => {
                        const id = String(i + 1);
                        return {
                            label: `Tab ${id}`,
                            key: id,
                            children: `Content of Tab ${id}`
                        };
                    })}
                />
            </div>
        </>
    )
}